var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"plural"},[_vm._v(_vm._s(_vm.text)),(parseInt(_vm.n) !== 1)?_c('span',[_vm._v(_vm._s(_vm.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }